
export const NAV_FIXED_TOP = "fixed_top";
export const NAV_INDEX = "index";